var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.34938C1 4.56697 1.45624 3.85641 2.16768 3.5308L7.05001 1.29628C8.37468 0.690012 9.88233 1.65805 9.88233 3.11486V15C9.88233 16.1046 8.9869 17 7.88232 17L2.99999 17C1.89543 17 1 16.1045 1 15V5.34938Z",
    fill: "white",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.43506C1 5.33049 1.89543 4.43506 3 4.43506H11.9198C13.0243 4.43506 13.9198 5.33049 13.9198 6.43506V15.0003C13.9198 16.1048 13.0243 17.0003 11.9198 17.0003H3C1.89543 17.0003 1 16.1048 1 15.0003V6.43506Z",
    fill: "white",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.22998,
    y: 12.5649,
    width: 6.45988,
    height: 1.47826,
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22998 7.3916H10.6899",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/menuLightBlueNoBgOutline.2c53fd03ec72d58981464972d4168ac7.svg";
export { ForwardRef as ReactComponent };